import { reduxKey } from './constants';
import { EmoteStreamType, EmoteStoreSlice } from './types';
import {
  init,
  initDone,
  initDoneAlready,
  switchStream,
  initStreamDone,
  streamLoadMore,
  streamLoadDone,
} from './actionCreators';
import { handleActions } from 'redux-actions';

const actionHandlers = handleActions<EmoteStoreSlice, any>(
  {
    [init.toString()]: state => ({
      ...state,
      isLoadingStream: true,
      activeStream: EmoteStreamType.OFFICIAL,
    }),
    [initDone.toString()]: (state, action) => ({
      ...state,
      isLoadingStream: false,
      isInitialized: true,
      officialEmotes: action.payload.result,
    }),
    [initDoneAlready.toString()]: state => ({
      ...state,
      isLoadingStream: false,
    }),
    [switchStream.toString()]: (state, action: ReturnType<typeof switchStream>) => ({
      ...state,
      isLoadingStream: true,
      cachedSearchQuery: action.payload.searchQuery,
      cachedSearchType: action.payload.searchType,
    }),
    [initStreamDone.toString()]: (state, action) => {
      if (action.payload.streamType === EmoteStreamType.SEARCH) {
        return {
          ...state,
          isLoadingStream: false,
          activeStream: action.payload.streamType,
          [`${action.payload.streamType}Emotes`]: action.payload.result,
        };
      }
      const current = state[`${action.payload.streamType}Emotes`];
      return {
        ...state,
        isLoadingStream: false,
        activeStream: action.payload.streamType,
        [`${action.payload.streamType}Emotes`]: current || action.payload.result,
      };
    },
    [streamLoadMore.toString()]: state => {
      return {
        ...state,
        isLoadingMore: true,
      };
    },
    [streamLoadDone.toString()]: (state, action) => {
      const current = state[`${action.payload.streamType}Emotes`];
      const newEmotes = action.payload.result && action.payload.result.results;
      const merged = {
        hasMore: action.payload.result.hasMore,
        nextOffset: action.payload.result.nextOffset,
        results: current && current.results && current.results.concat(newEmotes || []),
      };
      return {
        ...state,
        isLoadingMore: false,
        [`${action.payload.streamType}Emotes`]: merged,
      };
    },
  },
  {
    isInitialized: false,
    isLoadingMore: false,
    isLoadingStream: false,
    activeStream: EmoteStreamType.OFFICIAL,
    cachedSearchQuery: '',
    cachedSearchType: 'community',
  }
);

const reducers = {
  [reduxKey as string]: actionHandlers,
};

export default reducers;
